import React, { PureComponent } from "react";
import { connect } from "react-redux";

import {
  ModalContainer,
  Wrapper,
  Scroll,
  Row,
  Card,
  CardBody,
  Title
} from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";

import {
  appRedirect,
  editBulkUploadInfo,
  setUploadListHeaders
} from "app/NativeActions";

import HeaderStatus from "./HeaderStatus";
import BulkUploadCopy from "./BulkUploadCopy";
import HeaderSelectOption from "./HeaderSelectOption";
import SubmitButton from "./SubmitButton";
import Samples from "./Samples";
import moment from "moment";

const IGNORE_VALUE = "IGNORE";

class BulkUploadMapping extends PureComponent {
  constructor(props) {
    super(props);

    let header_edited_map = [];
    if (props.upload_list_info) {
      if (props.upload_list_info.header) {
        for (let i = 0; i < props.upload_list_info.header.length; i++) {
          header_edited_map.push({
            header_title: props.upload_list_info.header[i],
            header_index: i,
            header_mapped_value: ""
          });
        }
      }
    }

    this.state = {
      header_edited_map: header_edited_map,
      header_options: [
        {
          label: "N/A",
          value: ""
        },
        {
          label: "Full Address",
          value: "FULL_ADDRESS"
        },
        {
          label: "Address Line 1",
          value: "ADDRESS"
        },
        {
          label: "Address Line 2",
          value: "ADDRESS_2"
        },
        {
          label: "Address Number",
          value: "ADDRESS_RANGE"
        },
        {
          label: "Address Street",
          value: "ADDRESS_STREET"
        },
        {
          label: "City",
          value: "CITY"
        },
        {
          label: "State",
          value: "STATE"
        },
        {
          label: "Zipcode",
          value: "ZIP"
        },
        {
          label: "Phone Numbers (Seperated By Comma)",
          value: "PHONE"
        },
        {
          label: "Email Addresses (Seperated By Comma)",
          value: "EMAIL"
        }
      ]
    };
  }

  componentDidMount() {
    if (!this.props.upload_list_info) {
      this.props.appRedirect({
        redirect: "goBack",
        payload: { remove: "uploaded-list-mapping" }
      });
    }
  }

  checkIfAllPropertyAddressFieldsAreSelected() {
    let address_check = false;
    let address_street_check = false;
    let address_range_check = false;

    let city_check = false;
    let state_check = false;
    let zip_check = false;

    for (let i = 0; i < this.state.header_edited_map.length; i++) {
      switch (this.state.header_edited_map[i].header_mapped_value) {
        case "FULL_ADDRESS":
          return true;

        case "ADDRESS":
          address_check = true;
          break;

        case "ADDRESS_RANGE":
          address_range_check = true;
          break;

        case "ADDRESS_STREET":
          address_street_check = true;
          break;

        case "CITY":
          city_check = true;
          break;

        case "STATE":
          state_check = true;
          break;

        case "ZIP":
          zip_check = true;
          break;

        default:
          break;
      }
    }

    if (address_street_check && address_range_check) {
      address_check = true;
    }

    if (address_check && city_check && state_check && zip_check) {
      return true;
    }

    return false;
  }

  setHeaderOption(header_index, value) {
    this.setState({
      header_edited_map: this.state.header_edited_map.map((header, i) => {
        if (i === header_index) {
          return {
            ...header,
            header_mapped_value: value
          };
        }

        if (
          value === header.header_mapped_value &&
          value !== "" &&
          value !== IGNORE_VALUE &&
          (header.header_mapped_value === "FULL_ADDRESS" ||
            header.header_mapped_value === "ADDRESS" ||
            header.header_mapped_value === "ADDRESS_2" ||
            header.header_mapped_value === "ADDRESS_RANGE" ||
            header.header_mapped_value === "ADDRESS_STREET" ||
            header.header_mapped_value === "CITY" ||
            header.header_mapped_value === "STATE" ||
            header.header_mapped_value === "ZIP")
        ) {
          return {
            ...header,
            header_mapped_value: IGNORE_VALUE
          };
        }

        if (
          value === "FULL_ADDRESS" &&
          (header.header_mapped_value === "FULL_ADDRESS" ||
            header.header_mapped_value === "ADDRESS" ||
            header.header_mapped_value === "ADDRESS_2" ||
            header.header_mapped_value === "ADDRESS_RANGE" ||
            header.header_mapped_value === "ADDRESS_STREET" ||
            header.header_mapped_value === "CITY" ||
            header.header_mapped_value === "STATE" ||
            header.header_mapped_value === "ZIP")
        ) {
          return {
            ...header,
            header_mapped_value: IGNORE_VALUE
          };
        }

        if (
          value === "ADDRESS" &&
          (header.header_mapped_value === "ADDRESS_RANGE" ||
            header.header_mapped_value === "ADDRESS_STREET")
        ) {
          return {
            ...header,
            header_mapped_value: IGNORE_VALUE
          };
        }

        if (
          header.header_mapped_value === "ADDRESS" &&
          (value === "ADDRESS_RANGE" || value === "ADDRESS_STREET")
        ) {
          return {
            ...header,
            header_mapped_value: IGNORE_VALUE
          };
        }

        return header;
      })
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.header_edited_map !== this.state.header_edited_map) {
      if (
        this.checkIfAllPropertyAddressFieldsAreSelected() &&
        !this.state.address_fields_are_selected
      ) {
        this.setState({ address_fields_are_selected: true });

        this.setState({
          header_edited_map: this.state.header_edited_map.map((header, i) => {
            if (
              header.header_mapped_value === "" ||
              header.header_mapped_value === "N/A" ||
              header.header_mapped_value === null
            ) {
              return {
                ...header,
                header_mapped_value: IGNORE_VALUE
              };
            }
            return header;
          })
        });
      } else if (
        !this.checkIfAllPropertyAddressFieldsAreSelected() &&
        this.state.address_fields_are_selected
      ) {
        this.setState({ address_fields_are_selected: false });
      }
    }
  }

  submitList() {
    let mapping = [];
    for (let i = 0; i < this.state.header_edited_map.length; i++) {
      if (this.state.header_edited_map[i].header_mapped_value !== "") {
        mapping.push(this.state.header_edited_map[i].header_mapped_value);
      } else {
        mapping.push(IGNORE_VALUE);
      }
    }

    let new_list_name =
      "Bulk Import on " +
      moment().format("M/DD/YYYY") +
      " @ " +
      moment().format("h:mm a");

    this.props.setUploadListHeaders({
      token: this.props.token,
      bulk_job_id: this.props.upload_list_info.id,
      new_list_name: new_list_name,
      mapping: JSON.stringify(mapping),
      options: JSON.stringify({
        new_list_name: new_list_name
      })
    });
  }

  render() {
    if (this.props.upload_list_info) {
      return (
        <ModalContainer style={{ maxWidth: 1100 }}>
          <Header
            title={
              this.props.upload_list_info
                ? this.props.upload_list_info.row_count === 1
                  ? "Importing 1 Property"
                  : "Importing " +
                    this.props.upload_list_info.row_count +
                    " Properties"
                : "Importing Properties"
            }
            leftButtonIcon={this.props.mobile_toggle_drawer ? "logo" : "close"}
            leftButtonAction={() => {
              this.props.appRedirect({
                redirect: "goBack",
                payload: { type: "settings" }
              });
            }}
            rightButtonIcon={
              this.checkIfAllPropertyAddressFieldsAreSelected() ? "check" : ""
            }
            rightButtonAction={() => {
              this.submitList();
            }}
          />
          <Scroll>
            <Row
              style={{
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "flex-start"
              }}
            >
              <BulkUploadCopy />
              <Wrapper
                style={{
                  flex: 1,
                  minWidth: 400
                }}
              >
                <CardBody>
                  {this.state.header_edited_map.map((header, i) => {
                    return (
                      <Card key={i}>
                        <Wrapper
                          style={{
                            padding: 10,
                            borderBottomWidth: 1,
                            borderBottomStyle: "solid",
                            borderBottomColor: this.props.colors.border_color
                          }}
                        >
                          <Row
                            style={{
                              justifyContent: "space-between"
                            }}
                          >
                            <Title>{header.header_title}</Title>
                            <HeaderStatus
                              colors={this.props.colors}
                              header_item={header}
                              header_index={i}
                              setHeaderOption={this.setHeaderOption.bind(this)}
                            />
                          </Row>
                        </Wrapper>

                        <HeaderSelectOption
                          header_item={header}
                          header_index={i}
                          header_options={this.state.header_options}
                          setHeaderOption={this.setHeaderOption.bind(this)}
                        />

                        <Samples
                          header_item={header}
                          header_index={i}
                          upload_list_info={this.props.upload_list_info}
                        />
                      </Card>
                    );
                  })}
                  <SubmitButton
                    checkIfAllPropertyAddressFieldsAreSelected={this.checkIfAllPropertyAddressFieldsAreSelected.bind(
                      this
                    )}
                    submitList={this.submitList.bind(this)}
                  />
                </CardBody>
              </Wrapper>
            </Row>
          </Scroll>
        </ModalContainer>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, settings }) => {
  const { token, user } = auth;
  const { dark_mode, colors, upload_list_info } = settings;

  return {
    token,
    user,
    dark_mode,
    colors,
    upload_list_info
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  editBulkUploadInfo,
  setUploadListHeaders
})(BulkUploadMapping);
